import React from "react";

const Wallet = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M9.479 8.848l12.757-3.483L21.561 4a1.798 1.798 0 00-2.408-.812l-11.42 5.66h1.746zM26.196 5.464c-.159 0-.317.022-.475.065l-2.997.82-9.153 2.497H28.488l-.56-2.056a1.794 1.794 0 00-1.732-1.326zM30.36 10.107H3.802a1.794 1.794 0 00-1.736 1.326 1.86 1.86 0 00-.065.47v20.021c0 .992.805 1.797 1.797 1.797h26.56c.992 0 1.797-.805 1.797-1.797V26.91H21.492a3.057 3.057 0 01-3.055-3.055V19.86c0-.826.33-1.578.866-2.127a3.024 3.024 0 012.185-.924h10.666v-4.905a1.792 1.792 0 00-1.793-1.797z"
            fill={fill}
        />
        <path className="u_fill"
            d="M33.414 18.525a1.796 1.796 0 00-1.21-.47H21.49c-.992 0-1.797.804-1.797 1.796V23.85c0 .992.805 1.797 1.797 1.797h10.712c.205 0 .4-.035.582-.097A1.79 1.79 0 0034 23.85v-4c0-.524-.226-.998-.586-1.325zm-8.172 3.683a.899.899 0 01-.898.899h-.597a.899.899 0 01-.898-.899v-.596a.908.908 0 01.898-.898h.597c.496 0 .898.402.898.898v.596z"
            fill={fill}
        />
    </svg>
);

export default Wallet;
